import { h } from 'preact';
import clsx from 'clsx';
import { useEffect } from 'preact/hooks';
import RichText from '../utils/richtext';
import Image from '../utils/image';

const InternationalLandingPopup = ({data}) => {
  const {
    desktopImage,
    mobileImage,
    title,
    subtitle,
    storeLocator: {
      title: storeLocatorTitle,
      subtitle: storeLocatorSubtitle,
      ctaText,
      ctaLink,
    },
    emailSignup: {
      title: emailTitle,
      subtitle: emailSubtitle,
      disclaimerText,
      klaviyoFormId,
    },
  } = data;

  useEffect(() => {
    if (klaviyoFormId) {
      const timer = setTimeout(() => {
        if (window._learnq) {
          window._learnq.push(['refreshEmbeddedForms']);
        }
      }, 100);

      return () => clearTimeout(timer);
    }
    return undefined;
  }, [klaviyoFormId]);

  const mediaSection = (
    <div className="relative h-full laptop:pt-[100%] pt-[46.78%]">
      <Image
        classes={clsx(
          'w-full h-full object-cover object-center absolute inset-0',
          mobileImage && 'hidden laptop:block',
        )}
        src={desktopImage}
      />
      {mobileImage && (
        <Image
          classes="w-full h-full object-cover object-center absolute inset-0 laptop:hidden"
          src={mobileImage}
        />
      )}
    </div>
  );

  const titleSection = (
    <div className="text-center">
      <RichText data={title} customRootClass='!font-light !font-hoefler text-[24px] laptop:text-[38px] leading-[26px] laptop:leading-[42px] !mb-[2px] laptop:!mb-[4px]' />
      <p className="font-13">{subtitle}</p>
    </div>
  );

  const locatorSection = (
    <div className="text-center py-5 laptop:py-[30px] flex flex-col items-center">
      <h3 className="subheading-h3 font-light font-hoefler">{storeLocatorTitle}</h3>
      <p className="font-13">{storeLocatorSubtitle}</p>
      <a href={ctaLink} className="btn-primary cta-large mt-2.5 max-w-[260px] no-underline hover:bg-none" target="_blank" rel="noopener noreferrer">
        {ctaText}
      </a>
    </div>
  );

  const signupSection = (
    <div className="text-center flex flex-col items-center">
      <h3 className="subheading-h3 font-light font-hoefler">{emailTitle}</h3>
      <p className="font-13">{emailSubtitle}</p>
      <div className="international-landing-popup-klaviyo-form py-2.5 w-[260px]">
        <div className={`klaviyo-form-${klaviyoFormId}`}></div>
      </div>
      {disclaimerText && (
        <p className="utility-3">{disclaimerText}</p>
      )}
    </div>
  );

  return (
    <div className="flex flex-col laptop:flex-row">
      <div className="laptop:w-1/2">{mediaSection}</div>
      <div className="laptop:w-1/2 flex flex-col justify-center p-5 laptop:p-10">
        {titleSection}
        {locatorSection}
        {signupSection}
      </div>
    </div>
  );
};

export default InternationalLandingPopup;
